import React from 'react';
import { Card, CardContent, CardHeader, Box } from '@mui/material';
import { Line, Bar, Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

interface ChartCardProps {
  title: string;
  chartType: 'line' | 'bar' | 'pie';
  data: any;
  height?: number;
}

const ChartCard: React.FC<ChartCardProps> = ({ title, chartType, data, height = 300 }) => {
  const renderChart = () => {
    switch (chartType) {
      case 'line':
        return <Line data={data} options={{ maintainAspectRatio: false }} />;
      case 'bar':
        return <Bar data={data} options={{ maintainAspectRatio: false }} />;
      case 'pie':
        return <Pie data={data} options={{ maintainAspectRatio: false }} />;
      default:
        return null;
    }
  };

  return (
    <Card sx={{ height: '100%' }}>
      <CardHeader title={title} />
      <CardContent>
        <Box sx={{ height: height }}>
          {renderChart()}
        </Box>
      </CardContent>
    </Card>
  );
};

export default ChartCard;
